import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type ViewSheetToolbarProps = ComponentProps<"div">

function ViewSheetToolbar(props: ViewSheetToolbarProps) {
  const { className, ...divProps } = props
  return <div className={cn("view-sheet-toolbar", className)} {...divProps} />
}

export default ViewSheetToolbar
